<template>
  <div class="textareafield">
    <label
      :class="
        this.value && titleLabel == undefined
          ? 'textareafield__label filled'
          : 'textareafield__label'
      "
      :for="name"
      >{{ phName }}</label
    >
    <textarea
      class="textareafield__input"
      :id="name"
      :name="name"
      :rows="rows"
      :cols="cols"
      @input="$emit('input', $event.target.value)"
    >
    </textarea>
  </div>
</template>
<script>
export default {
  name: "TextAreaField",
  props: [
    "titleLabel",
    "showError",
    "errorLabel",
    "value",
    "name",
    "phName",
    "autofocus",
    "rows",
    "cols",
  ],
  mounted() {
    if (this.autofocus) this.$refs.input.focus();
  },
  methods: {
    btnAdd() {
      this.$emit("btnAdd");
    },
    updateValue() {
      this.$emit("input", this.$refs.input.value);
    },
    onKeyUp() {
      this.$emit("keyup");
    },
    onKeyUpEnter() {
      this.$emit("keyupEnter");
    },
    onBlur() {
      this.$emit("onBlur");
    },
  },
};
</script>